import { render } from "./Journal_Mismatch.vue?vue&type=template&id=b0e5ddfc&scoped=true"
import script from "./Journal_Mismatch.vue?vue&type=script&lang=js"
export * from "./Journal_Mismatch.vue?vue&type=script&lang=js"

import "./Journal_Mismatch.vue?vue&type=style&index=0&id=b0e5ddfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e5ddfc"]])

export default __exports__